export default __webpack_public_path__ + "static/media/insta.602025d9.png";